(function () {
  function getRate() {
    if (
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.rate
    ) {
      var rate = parseFloat(window.Shopify.currency.rate);
      if (!isNaN(rate) && rate > 0) return rate;
    }
    return 1;
  }

  function evaluate(badge) {
    var price = parseInt(badge.getAttribute('data-fsb-price'), 10);
    var base = parseInt(badge.getAttribute('data-fsb-threshold'), 10);

    if (isNaN(price) || isNaN(base)) return;

    if (price >= base * getRate()) {
      badge.removeAttribute('hidden');
    } else {
      badge.setAttribute('hidden', '');
    }
  }

  function run(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var badges = scope.querySelectorAll('[data-fsb-badge]');

    for (var i = 0; i < badges.length; i++) {
      evaluate(badges[i]);
    }

    if (root && root.hasAttribute && root.hasAttribute('data-fsb-badge')) {
      evaluate(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (event) {
    run(event.target);
  });

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;

        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) {
            run(added[j]);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  window.fsbRefreshBadges = run;
})();
